import { render, staticRenderFns } from "./CustomField.vue?vue&type=template&id=97a4a64e"
import script from "./CustomField.vue?vue&type=script&lang=ts"
export * from "./CustomField.vue?vue&type=script&lang=ts"
import style0 from "./CustomField.vue?vue&type=style&index=0&id=97a4a64e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports